import { Component, inject } from '@angular/core';
import { PaymentModeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PaymentModeCreateDto,
  PaymentModeDto,
  PaymentModeExcelDownloadDto,
  PaymentModeUpdateDto,
} from '../proxy/controlling/dtos/payment-mode';
import { PAYMENTMODE_CONFIG, PAYMENTMODE_FIELDS } from './payment-mode.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-payment-mode',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PaymentModeService, ConfirmationService],
  templateUrl: './payment-mode.html',
  styleUrl: './payment-mode.scss',
})
export class PaymentMode extends BaseCrudComponent<
  PaymentModeDto,
  PaymentModeCreateDto,
  PaymentModeUpdateDto,
  PaymentModeExcelDownloadDto
> {
  service = inject(PaymentModeService);
  config = PAYMENTMODE_CONFIG;
  fields = PAYMENTMODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PaymentModeDto): PaymentModeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PaymentMode';
  }
}
